import { AppService } from "src/app/_services/app.service";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";
import { ClientService } from "src/app/_services/client.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { DatesHelpers } from "src/app/helpers/date";
import { TranslateService } from "@ngx-translate/core"; // if using ngx-translate
import { PusherService } from "src/app/_services/pusher.service";
import { ConfirmationModalComponent } from "../confirmation-modal/confirmation-modal.component";

@Component({
  selector: "app-meeting-demand-modal",
  templateUrl: "./meeting-demand-modal.component.html",
  styleUrls: ["./meeting-demand-modal.component.scss"],
  standalone: false,
})
export class MeetingDemandModalComponent implements OnInit, OnChanges {
  @Input() data?: any[];
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  isLoading: boolean = false;
  demand!: any;
  role: any;
  choice = "accept";
  meet!: {
    id: number;
    position: string;
    remarque: string;
    time_end: string;
    time_start: string;
    titre: string;
    updated_at: string;
    date: string;
  };
  constructor(
    private datesHelpers: DatesHelpers,
    private clientService: ClientService,
    private localStorageServices: LocalStorageService,
    private navController: NavController,
    private translate: TranslateService,
    private laravelEchoService: PusherService,
    private modalCtrl: ModalController,
    private appService: AppService
  ) {
    this.role = this.localStorageServices.getUserRole();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["data"].currentValue[0]) {
      let meet = changes["data"].currentValue[0];
      let demand = changes["data"].currentValue[0]?.demande_id;
      this.meet = meet;
      this.demand = demand;
    }
  }

  convertDate(date: string): string {
    let dateArray = date.split("-");
    let year = dateArray[0];
    let mounth = this.datesHelpers.getMonthAbbreviation(
      Number(dateArray[1]) - 1
    );
    let day = dateArray[2];
    return `${day} ${mounth} ${year}`;
  }
  convertTime(time: string): string {
    let timeArray = time.split(":");
    let formattedTime = `${timeArray[0]}:${timeArray[1]}`;
    return formattedTime;
  }
  displayTime(from: string, to: string): string {
    let result = `${this.translate.instant("RDV_PAGE.FROM")} ${this.convertTime(
      from
    )} ${this.translate.instant("RDV_PAGE.TO")} ${this.convertTime(to)}`;
    return result;
  }

  ngOnInit() {}

  handleValid() {
    this.isLoading = true;
    let payload = {
      id: this.meet.id,
      statut: this.choice === "accept" ? "ACCEPTED" : "REFUSED",
    };
    this.clientService.confirmMeeting(payload).subscribe((res: any) => {
      this.closeModal();
      this.isLoading = false;
      setTimeout(() => {
        this.goTo("");
      }, 200);
    });
  }

  handleCancle() {
    let payload = {
      id: this.meet.id,
      statut: "REFUSED",
    };
    this.clientService.confirmMeeting(payload).subscribe((res: any) => {
      this.closeModal();
      setTimeout(() => {
        this.goTo("");
      }, 200);
    });
  }

  async cancelDemande() {
    this.appService.dispatchModal("CANCEL_DEMAND_MODAL", {
      open: true,
      id: this.demand.id,
    });
  }

  closeModal() {
    this.laravelEchoService.resetMeetingDemand();
  }
  goTo(path: string) {
    let baseUrl = "";
    switch (this.role) {
      case "client":
        baseUrl = "particulier";
        break;
      case "prestataire":
        baseUrl = "prestataire";
        break;
    }
    this.navController.navigateForward(["/" + baseUrl + "/" + path]);
  }
}
